import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const API_URL = window.location.origin;

const MagicLink = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const key = searchParams.get('key');
    const email = searchParams.get('email') || 'me@iamnaomithomas.com';
    
    const validKey = 'dd2026admin';
    
    if (key === validKey) {
      // Call backend to create proper session for admin
      fetch(`${API_URL}/api/auth/magic?email=${encodeURIComponent(email)}&key=${encodeURIComponent(key)}`, {
        method: 'POST',
        credentials: 'include',
      })
        .then(res => {
          if (res.ok) return res.json();
          throw new Error('Failed to create session');
        })
        .then(data => {
          console.log('[MagicLink] Session created:', data);
          
          // Store all values synchronously
          try {
            localStorage.setItem('auth_session_token', data.session_token || '');
            localStorage.setItem('soiree_email', email);
            localStorage.setItem('soiree_approved', 'true');
            localStorage.setItem('frontrow_email', email);
            localStorage.setItem('frontrow_approved', 'true');
            
            // Force localStorage to persist
            const check = localStorage.getItem('auth_session_token');
            console.log('[MagicLink] Token verified:', check ? 'YES' : 'NO');
          } catch (e) {
            console.error('[MagicLink] localStorage error:', e);
          }
          
          setStatus('success');
          
          // Use navigate with state to pass token
          setTimeout(() => {
            // Pass token in URL hash as backup
            window.location.replace(`/admin#token=${data.session_token}`);
          }, 500);
        })
        .catch(err => {
          console.error('[MagicLink] Backend session failed:', err);
          localStorage.setItem('soiree_email', email);
          localStorage.setItem('soiree_approved', 'true');
          localStorage.setItem('frontrow_email', email);
          localStorage.setItem('frontrow_approved', 'true');
          
          setStatus('fallback');
          setTimeout(() => {
            window.location.replace('/admin');
          }, 500);
        });
    } else {
      navigate('/', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white">
          {status === 'loading' && 'Signing you in...'}
          {status === 'success' && 'Session created! Redirecting...'}
          {status === 'fallback' && 'Using local mode. Redirecting...'}
        </p>
      </div>
    </div>
  );
};

export default MagicLink;
